import React from 'react';
import type { SlashCommand } from 'src/modules/shared/types/editor/slash-commands.types';
import { Text } from 'src/modules/shared/components/atoms/text';
import {
  getMenuItemClasses,
  getMenuItemContentClasses,
  getMenuItemContentColor,
  getMenuItemContentWeight,
  menuListClasses,
} from 'src/modules/shared/styles/dropdown.styles';

export interface InlineTokensSlashState {
  isOpen: boolean;
  query: string;
  activeIndex: number;
}

interface InlineTokensSlashMenuProps {
  state: InlineTokensSlashState | null;
  commands: SlashCommand[];
  onSelect: (command: SlashCommand) => void;
}

export const InlineTokensSlashMenu: React.FC<InlineTokensSlashMenuProps> = ({
  state,
  commands,
  onSelect,
}) => {
  if (!state || !state.isOpen || commands.length === 0) {
    return null;
  }

  return (
    <div
      className={`absolute mt-1 w-64 rounded-md border border-secondary-200 bg-white shadow-lg ${menuListClasses}`}
    >
      {commands.map((command, index) => {
        const isActive = index === state.activeIndex;
        const itemClasses = getMenuItemClasses('sm', false, isActive, false);

        return (
          <div
            key={command.id}
            className={`flex items-center justify-between gap-2 ${itemClasses}`}
            onMouseDown={(event) => {
              event.preventDefault();
              onSelect(command);
            }}
          >
            <Text
              size="paragraph"
              weight={getMenuItemContentWeight(isActive)}
              color={getMenuItemContentColor(isActive)}
              className={getMenuItemContentClasses()}
            >
              {command.label}
            </Text>

            <Text size="tiny" color="secondary">
              {command.kind}
            </Text>
          </div>
        );
      })}
    </div>
  );
};
